/* VELSENOR v24 — immediate controls; visual motion lives in voralis-motion.js. */
document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');
document.addEventListener('DOMContentLoaded', () => {
  const toggle=document.querySelector('[data-menu-toggle]'),menu=document.querySelector('[data-mobile-menu]');
  if(toggle&&menu)toggle.addEventListener('click',()=>{
    const open=toggle.getAttribute('aria-expanded')==='true';
    toggle.setAttribute('aria-expanded',String(!open));menu.hidden=open;
    document.body.classList.toggle('menu-open',!open);
  });
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches||!document.body.classList.contains('motion-enabled');
  const revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(entry.isIntersecting){entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target);}
  }),{rootMargin:'80px 0px',threshold:.01});
  const reveal=scope=>scope.querySelectorAll('[data-reveal]').forEach(el=>reduced?el.classList.add('is-visible'):revealObserver.observe(el));
  reveal(document);document.addEventListener('shopify:section:load',event=>reveal(event.target));
  document.querySelectorAll('[data-market-tab]').forEach(tab=>tab.addEventListener('click',()=>{
    const scope=tab.closest('.market-showcase'),id=tab.dataset.marketTab;
    scope.querySelectorAll('[data-market-tab]').forEach(t=>t.classList.toggle('is-active',t===tab));
    scope.querySelectorAll('[data-market-panel]').forEach(p=>p.classList.toggle('is-active',p.dataset.marketPanel===id));
  }));
  document.querySelectorAll('[data-auto-universes]').forEach(scope=>{
    scope.querySelectorAll('[data-universe-tab]').forEach(tab=>tab.addEventListener('click',()=>{
      const id=tab.dataset.universeTab;
      scope.querySelectorAll('[data-universe-tab]').forEach(t=>{const active=t===tab;t.classList.toggle('is-active',active);t.setAttribute('aria-selected',String(active));});
      scope.querySelectorAll('[data-universe-panel]').forEach(panel=>panel.classList.toggle('is-active',panel.dataset.universePanel===id));
    }));
  });
  document.querySelectorAll('[data-variant-select]').forEach(select=>select.addEventListener('change',()=>{
    const option=select.options[select.selectedIndex],price=select.closest('.product-panel')?.querySelector('[data-price]');
    if(price&&option.dataset.displayPrice)price.textContent=option.dataset.displayPrice;
  }));
});

/* VELSENOR v12 — cinematic interactions */
document.addEventListener('DOMContentLoaded',()=>{
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches||!document.body.classList.contains('motion-enabled');

  const prelude=document.querySelector('[data-lc-prelude]');
  if(prelude){
    const finish=()=>prelude.classList.add('is-complete');
    requestAnimationFrame(finish);
  }

  document.querySelectorAll('[data-hero-universe]').forEach(scope=>{
    const panels=[...scope.querySelectorAll('[data-hero-world-panel]')];
    const tabs=[...scope.querySelectorAll('[data-hero-world-tab]')];
    if(panels.length<2||tabs.length!==panels.length)return;
    let active=0,timer,paused=reduced;
    const show=index=>{
      active=(index+panels.length)%panels.length;
      panels.forEach((panel,i)=>{
        const selected=i===active;
        panel.classList.toggle('is-active',selected);
        panel.setAttribute('aria-hidden',String(!selected));
      });
      tabs.forEach((tab,i)=>{
        const selected=i===active;
        tab.classList.toggle('is-active',selected);
        tab.setAttribute('aria-pressed',String(selected));
      });
    };
    const schedule=()=>{
      clearInterval(timer);
      if(!paused)timer=setInterval(()=>show(active+1),6500);
    };
    tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>{show(index);schedule()});
      tab.addEventListener('keydown',event=>{
        if(event.key!=='ArrowRight'&&event.key!=='ArrowLeft')return;
        event.preventDefault();
        const next=event.key==='ArrowRight'?index+1:index-1;
        tabs[(next+tabs.length)%tabs.length].focus();
        show(next);schedule();
      });
    });
    scope.addEventListener('mouseenter',()=>{paused=true;schedule()});
    scope.addEventListener('mouseleave',()=>{paused=reduced;schedule()});
    scope.addEventListener('focusin',()=>{paused=true;schedule()});
    scope.addEventListener('focusout',event=>{if(!scope.contains(event.relatedTarget)){paused=reduced;schedule()}});
    document.addEventListener('visibilitychange',()=>{paused=document.hidden||reduced;schedule()});
    show(0);schedule();
  });

  const menu=document.querySelector('[data-mobile-menu]');
  const menuToggle=document.querySelector('[data-menu-toggle]');
  if(menu&&menuToggle){
    const closeMenu=()=>{
      menu.hidden=true;
      menuToggle.setAttribute('aria-expanded','false');
      menuToggle.setAttribute('aria-label',menuToggle.dataset.labelOpen||'Open menu');
      document.body.classList.remove('menu-open');
    };
    menuToggle.addEventListener('click',()=>menuToggle.setAttribute('aria-label',menuToggle.getAttribute('aria-expanded')==='true'?(menuToggle.dataset.labelClose||'Close menu'):(menuToggle.dataset.labelOpen||'Open menu')));
    menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',closeMenu));
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!menu.hidden){closeMenu();menuToggle.focus()}});
  }

  const imprint=document.querySelector('[data-imprint]');
  if(imprint){
    const openImprint=()=>{imprint.open=true};
    document.querySelectorAll('[data-open-imprint]').forEach(link=>link.addEventListener('click',openImprint));
    if(location.hash==='#impressum')openImprint();
    addEventListener('hashchange',()=>{if(location.hash==='#impressum')openImprint()});
  }

});

/* VELSENOR v15 — native European localization concierge */
document.addEventListener('DOMContentLoaded',()=>{
  const languageSwitchers=[...document.querySelectorAll('[data-language-switcher]')];
  const languageDetails=[...document.querySelectorAll('[data-language-details]')];

  languageDetails.forEach(details=>{
    details.addEventListener('toggle',()=>{
      if(!details.open)return;
      languageDetails.forEach(other=>{if(other!==details)other.open=false});
      requestAnimationFrame(()=>details.querySelector('[data-language-search]')?.focus({preventScroll:true}));
    });
  });

  languageSwitchers.forEach(switcher=>{
    const search=switcher.querySelector('[data-language-search]');
    const options=[...switcher.querySelectorAll('[data-language-code]')];
    const empty=switcher.querySelector('[data-language-empty]');
    options.forEach(option=>option.addEventListener('click',()=>{
      try{localStorage.setItem('lc-language-preference',`manual:${option.dataset.languageCode}`)}catch(error){}
    }));
    if(!search)return;
    search.addEventListener('keydown',event=>{if(event.key==='Enter')event.preventDefault()});
    search.addEventListener('input',()=>{
      const query=search.value.trim().toLocaleLowerCase();
      let matches=0;
      options.forEach(option=>{
        const visible=!query||(option.dataset.languageSearchValue||'').includes(query);
        option.hidden=!visible;
        if(visible)matches+=1;
      });
      if(empty)empty.hidden=matches!==0;
    });
  });

  addEventListener('pointerdown',event=>{
    languageDetails.forEach(details=>{if(details.open&&!details.contains(event.target))details.open=false});
  },{passive:true});
  addEventListener('keydown',event=>{if(event.key==='Escape')languageDetails.forEach(details=>details.open=false)});

  const menuToggle=document.querySelector('[data-menu-toggle]');
  menuToggle?.addEventListener('click',()=>requestAnimationFrame(()=>{
    const open=menuToggle.getAttribute('aria-expanded')==='true';
    menuToggle.setAttribute('aria-label',open?menuToggle.dataset.labelClose:menuToggle.dataset.labelOpen);
  }));


  document.querySelectorAll('[data-rail-toggle]').forEach(toggle=>toggle.addEventListener('click',()=>requestAnimationFrame(()=>{
    toggle.setAttribute('aria-label',toggle.textContent.trim()==='▶'?toggle.dataset.labelPlay:toggle.dataset.labelPause);
  })));

  if(document.body.dataset.autoLanguage!=='true')return;
  const languageData=document.getElementById('VelsenorLanguages');
  if(!languageData)return;
  try{
    const stored=localStorage.getItem('lc-language-preference');
    if(stored?.startsWith('manual:'))return;
    if(sessionStorage.getItem('lc-language-redirected')==='true')return;
    const available=JSON.parse(languageData.textContent||'[]');
    const current=(document.documentElement.lang||'').toLowerCase();
    const browserLanguages=navigator.languages?.length?navigator.languages:[navigator.language];
    let preferred=null;
    for(const candidateValue of browserLanguages){
      const candidate=(candidateValue||'').toLowerCase();
      preferred=available.find(language=>language.iso_code.toLowerCase()===candidate)||available.find(language=>language.iso_code.toLowerCase().split('-')[0]===candidate.split('-')[0]);
      if(preferred)break;
    }
    if(!preferred||preferred.iso_code.toLowerCase()===current)return;
    const option=[...document.querySelectorAll('[data-language-code]')].find(button=>button.dataset.languageCode===preferred.iso_code);
    if(!option)return;
    sessionStorage.setItem('lc-language-redirected','true');
    localStorage.setItem('lc-language-preference',`auto:${preferred.iso_code}`);
    option.form?.requestSubmit?option.form.requestSubmit(option):option.click();
  }catch(error){}
});


/* VELSENOR v24 — bounded click rewards without forced layout reads. */
document.addEventListener('DOMContentLoaded',()=>{
  if(document.body.dataset.clickRewards!=='true')return;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const configured=document.body.dataset.clickRewardStyle||'cinematic';
  const style=['subtle','cinematic','maximal'].includes(configured)?configured:'cinematic';
  const interactiveSelector='a,button,summary,[role="button"],input[type="submit"],input[type="button"],[data-click-reward]';
  const coarse=matchMedia('(pointer: coarse)').matches;
  const particleCount=reduced?0:{subtle:6,cinematic:12,maximal:coarse?12:22}[style];
  const activeRewards=[];
  const highlights=new WeakMap();
  const duration={subtle:720,cinematic:980,maximal:1340}[style];

  const reward=(x,y,target)=>{
    const limit=coarse?2:4;
    while(activeRewards.length>=limit)activeRewards.shift().remove();
    const effect=document.createElement('span');
    effect.className=`lc-click-reward lc-click-reward--${style}`;
    effect.setAttribute('aria-hidden','true');
    effect.style.left=`${x}px`;
    effect.style.top=`${y}px`;
    effect.innerHTML='<i class="lc-click-reward__ring lc-click-reward__ring--outer"></i><i class="lc-click-reward__ring lc-click-reward__ring--inner"></i>'+(style==='maximal'?'<i class="lc-click-reward__ring lc-click-reward__ring--echo"></i><i class="lc-click-reward__flare"></i>':'')+'<i class="lc-click-reward__core"></i>';
    for(let index=0;index<particleCount;index++){
      const particle=document.createElement('b');
      const angle=360/particleCount*index+(Math.random()-.5)*11;
      const distance=(style==='subtle'?34:style==='maximal'?(coarse?82:112):58)*(0.76+Math.random()*.42);
      particle.className='lc-click-reward__particle';
      particle.style.setProperty('--lc-reward-angle',`${angle.toFixed(2)}deg`);
      particle.style.setProperty('--lc-reward-distance',`${distance.toFixed(2)}px`);
      particle.style.setProperty('--lc-reward-delay',`${(Math.random()*(style==='maximal'?90:55)).toFixed(0)}ms`);
      effect.append(particle);
    }
    document.body.append(effect);
    activeRewards.push(effect);
    if(target){
      clearTimeout(highlights.get(target));
      target.classList.add('is-click-rewarded');
      highlights.set(target,setTimeout(()=>{target.classList.remove('is-click-rewarded');highlights.delete(target)},Math.min(duration,690)));
    }
    setTimeout(()=>{effect.remove();const index=activeRewards.indexOf(effect);if(index!==-1)activeRewards.splice(index,1)},duration+180);
  };

  document.addEventListener('pointerdown',event=>{
    if(event.button!==undefined&&event.button!==0)return;
    const target=event.target.closest?.(interactiveSelector);
    if(!target||target.matches(':disabled,[aria-disabled="true"]')||target.closest('[data-voralis-sound]'))return;
    reward(event.clientX,event.clientY,target);
  },{passive:true});

  document.addEventListener('click',event=>{
    if(event.detail!==0)return;
    const target=event.target.closest?.(interactiveSelector);
    if(!target||target.matches(':disabled,[aria-disabled="true"]')||target.closest('[data-voralis-sound]'))return;
    const rect=target.getBoundingClientRect();
    reward(rect.left+rect.width/2,rect.top+rect.height/2,target);
  });

  if(reduced)document.documentElement.classList.add('lc-rewards-reduced');
});


/* VELSENOR v17 — dynamic viewport and resilient mobile navigation */
;(()=>{
  const root=document.documentElement;
  let viewportRaf=0;
  const syncViewport=()=>{
    const viewport=window.visualViewport;
    const height=Math.round(viewport?.height||innerHeight);
    const width=Math.round(viewport?.width||innerWidth);
    root.style.setProperty('--lc-viewport-height',`${height}px`);
    root.style.setProperty('--lc-viewport-width',`${width}px`);
    viewportRaf=0;
  };
  const requestViewportSync=()=>{if(!viewportRaf)viewportRaf=requestAnimationFrame(syncViewport)};
  syncViewport();
  addEventListener('resize',requestViewportSync,{passive:true});
  addEventListener('orientationchange',requestViewportSync,{passive:true});
  window.visualViewport?.addEventListener('resize',requestViewportSync,{passive:true});

  document.addEventListener('DOMContentLoaded',()=>{
    const menuToggle=document.querySelector('[data-menu-toggle]');
    const menu=document.querySelector('[data-mobile-menu]');
    if(!menuToggle||!menu)return;
    menuToggle.addEventListener('click',()=>requestAnimationFrame(()=>{
      if(menuToggle.getAttribute('aria-expanded')==='true')menu.querySelector('nav a')?.focus({preventScroll:true});
    }));
    const desktopQuery=matchMedia('(min-width: 1181px)');
    const closeAtDesktop=event=>{
      if(!event.matches||menu.hidden)return;
      menu.hidden=true;
      menuToggle.setAttribute('aria-expanded','false');
      menuToggle.setAttribute('aria-label',menuToggle.dataset.labelOpen||'Open menu');
      document.body.classList.remove('menu-open');
    };
    if(desktopQuery.addEventListener)desktopQuery.addEventListener('change',closeAtDesktop);
    else desktopQuery.addListener?.(closeAtDesktop);
  });
})();

/* Film playback is managed centrally by voralis-films.js. */
